import AVdxbRadio from './index.vue';

AVdxbRadio.install = app => {
  app.component(AVdxbRadio.name, AVdxbRadio);
};

export default AVdxbRadio;
